import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { BaseController } from "../../../core/controllers/base.controller";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { JobAssigneePickerItemModel, JobAssigneePickerModel } from "./job-assignee-picker.model";

@Injectable()
export class JobAssigneePickerController extends BaseController {

    protected _model$ = new Subject<any>();

    constructor(
        protected appFacade: VasAppFacade
    ) {
        super();
    }

    get model$(): Observable<any> {
        return this.appFacade.objects.user.store.getAll()
            .takeUntil(this.ngUnsubscribe)
            .map(users => {
                return new JobAssigneePickerModel({
                    items: users.map(user => new JobAssigneePickerItemModel({user}))
                        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
                });
            });
    }

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-assignee-picker/job-assignee-picker.controller.ts